up.macro('[up-tooltip]', function (opener) {
    up.migrate.warn('[up-tooltip] has been deprecated. A [title] was set instead.');
    up.element.setMissingAttr(opener, 'title', opener.getAttribute('up-tooltip'));
});
